'use strict'

const { VUE_APP_ORDERS_URL } = process.env

export default async ({ jwt, refundObj }) => {
  const response = await fetch(`${VUE_APP_ORDERS_URL}/refund`, {
    method: 'PUT',
    headers: {
      Authorization: jwt,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(refundObj),
    timeout: 8000
  })
  if (!response.ok) throw (response.statusText)
}
